// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ci { position: relative; width: 100%; }

.ci input {
  width: 100%;
  font-size: 12px;
  padding: 2px 5px;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 2px;
  color: var(--text-primary);
  outline: none;
}
.ci input:focus { border-color: var(--accent-light); }
.ci-dis .ci input { opacity: 0.5; cursor: not-allowed; }

.ci-drop {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 3px;
  box-shadow: 0 6px 20px rgba(0,0,0,.5);
  max-height: 200px;
  overflow-y: auto;
}

.ci-opt {
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
  color: var(--text-primary);
  white-space: nowrap;
}
.ci-opt.ci-hi  { background: var(--bg-hover); }
.ci-opt.ci-sel { color: var(--accent-light); }
`, "",{"version":3,"sources":["webpack://./src/components/common/ComboInput.css"],"names":[],"mappings":"AAAA,MAAM,kBAAkB,EAAE,WAAW,EAAE;;AAEvC;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;AACA,kBAAkB,iCAAiC,EAAE;AACrD,oBAAoB,YAAY,EAAE,mBAAmB,EAAE;;AAEvD;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;AACA,iBAAiB,2BAA2B,EAAE;AAC9C,iBAAiB,0BAA0B,EAAE","sourcesContent":[".ci { position: relative; width: 100%; }\n\n.ci input {\n  width: 100%;\n  font-size: 12px;\n  padding: 2px 5px;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  color: var(--text-primary);\n  outline: none;\n}\n.ci input:focus { border-color: var(--accent-light); }\n.ci-dis .ci input { opacity: 0.5; cursor: not-allowed; }\n\n.ci-drop {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  box-shadow: 0 6px 20px rgba(0,0,0,.5);\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.ci-opt {\n  padding: 5px 10px;\n  font-size: 12px;\n  cursor: pointer;\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n.ci-opt.ci-hi  { background: var(--bg-hover); }\n.ci-opt.ci-sel { color: var(--accent-light); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
